import Vue from "vue";
import axios from "axios";

class AppApi {
  instance;
  constructor() {
    this.instance = axios.create();
  }

  call(action, method, data) {
    let request = {
      method: method,
      url:
        process.env.VUE_APP_API_URL + (action[0] === "/" ? "" : "/") + action,
      headers: {
        Authorization: "Bearer " + Vue.auth.token()
      }
    };

    if (method === "GET") {
      request.params = data;
    } else {
      request.data = data;
    }

    return this.instance.request(request);
  }


  postAuthRegister(data) {
    return this.call("/auth/register", "POST", data);
  }

  getHome() {
    return this.call("/home", "GET");
  }

  //users
  getUser(id) {
    return this.call("/users/" + id, "GET");
  }
  getUsers(data) {
    return this.call("/users", "GET", data);
  }

  putUserProfile(data) {
    return this.call("/users/profile", "PUT", data);
  }

  postUserPushNotification(data) {
    return this.call("/push-notifications", "POST", data);
  }

  updateUserProfile(data) {
    const { id, name, email, phone, cpf } = data;
    return this.call(`/users/profile/${id}`, "PUT", {
      name,
      email,
      phone,
      cpf
    });
  }

  deleteUser(id, data) {
    return this.call(`/users/${id}`, "DELETE", data);
  }

  deleteUserProfile(data) {
    return this.call("/users/profile", "DELETE", data);
  }

  getTempUsers(data) {
    return this.call("/temp-users", "GET", data);
  }

  resendSmsToTempUser(id) {
    return this.call(`/temp-users/${id}/resend-sms`, "POST");
  }

  //companies
  getCompanies(data) {
    return this.call("/companies", "GET", data);
  }
  getCompany(id) {
    return this.call("/companies/" + id, "GET");
  }
  postCompany(data) {
    return this.call("/companies", "POST", data);
  }
  putCompany(id, data) {
    return this.call("/companies/" + id, "PUT", data);
  }

  //user industry
  deleteUserIndustry(id) {
    return this.call("/user-industries/" + id, "DELETE");
  }
  postUserIndustry(data) {
    return this.call("/user-industries", "POST", data);
  }

  //romaneios
  getRomaneios(data) {
    return this.call("/romaneios", "GET", data);
  }
  getRomaneio(id) {
    return this.call("/romaneios/" + id, "GET");
  }
  putApproveRomaneio(id) {
    return this.call("/romaneios/approve/" + id, "PUT", []);
  }
  getRomaneioAuxs() {
    return this.call("/portal/romaneios/auxs", "GET");
  }
  getRomaneioImages(id, nr_sequencial) {
    return this.call(
      "/portal/romaneios/images/" + id + "/" + nr_sequencial,
      "GET"
    );
  }

  //propriedades
  getProperties(data) {
    return this.call("/properties", "GET", data);
  }
  getProperty(id) {
    return this.call("/properties/" + id, "GET");
  }
  postProperty(data) {
    return this.call("/properties", "POST", data);
  }
  putProperty(id, data) {
    return this.call(`/properties/${id}`, "PUT", data);
  }

  //Property Active Control
  putPropertyActive(id) {
    return this.call(`properties/eco-active/${id}`, "PUT");
  }

  //contacts
  postPropertyContact(data) {
    return this.call("/properties/contacts", "POST", data);
  }
  putPropertyContact(id, data) {
    return this.call("/properties/contacts/" + id, "PUT", data);
  }
  destroyPropertyContact(id) {
    return this.call("/properties/contacts/" + id, "DELETE");
  }

  //explorer
  getExplorers(data) {
    return this.call("/explorers", "GET", data);
  }
  getExplorersAll(data) {
    return this.call("/explorers/all", "GET", data);
  }
  postExplorer(data) {
    return this.call("/explorers", "POST", data);
  }
  putExplorer(id, data) {
    return this.call("/explorers/" + id, "PUT", data);
  }
  destroyExplorer(id) {
    return this.call("/explorers/" + id, "DELETE");
  }

  //raças
  getAuxBreeds(data) {
    return this.call("/aux/breeds", "GET", data);
  }
  getAuxBreed(id) {
    return this.call("/aux/breeds/" + id, "GET");
  }
  postAuxBreed(data) {
    return this.call("/aux/breeds", "POST", data);
  }
  putAuxBreed(id, data) {
    return this.call("/aux/breeds/" + id, "PUT", data);
  }
  deleteAuxBreed(id, data) {
    return this.call("/aux/breeds/" + id, "DELETE", data);
  }

  //acabamento
  getAuxFinishes(data) {
    return this.call("/aux/finishes", "GET", data);
  }
  getAuxFinish(id) {
    return this.call("/aux/finishes/" + id, "GET");
  }
  postAuxFinish(data) {
    return this.call("/aux/finishes", "POST", data);
  }
  putAuxFinish(id, data) {
    return this.call("/aux/finishes/" + id, "PUT", data);
  }
  deleteAuxFinish(id, data) {
    return this.call("/aux/finishes/" + id, "DELETE", data);
  }

  //motivos
  getAuxCases(data) {
    return this.call("/aux/cases", "GET", data);
  }
  getAuxCase(id) {
    return this.call("/aux/cases/" + id, "GET");
  }
  postAuxCase(data) {
    return this.call("/aux/cases", "POST", data);
  }
  putAuxCase(id, data) {
    return this.call("/aux/cases/" + id, "PUT", data);
  }
  deleteAuxCase(id, data) {
    return this.call("/aux/cases/" + id, "DELETE", data);
  }

  //categoria
  getAuxCategories(data) {
    return this.call("/aux/categories", "GET", data);
  }
  getAuxCategory(id) {
    return this.call("/aux/categories/" + id, "GET");
  }
  postAuxCategory(data) {
    return this.call("/aux/categories", "POST", data);
  }
  putAuxCategory(id, data) {
    return this.call("/aux/categories/" + id, "PUT", data);
  }
  deleteAuxCategory(id, data) {
    return this.call("/aux/categories/" + id, "DELETE", data);
  }

  //conformação
  getAuxConformations(data) {
    return this.call("/aux/conformations", "GET", data);
  }
  getAuxConformation(id) {
    return this.call("/aux/conformations/" + id, "GET");
  }
  postAuxConformation(data) {
    return this.call("/aux/conformations", "POST", data);
  }
  putAuxConformation(id, data) {
    return this.call("/aux/conformations/" + id, "PUT", data);
  }
  deleteAuxConformation(id, data) {
    return this.call("/aux/conformations/" + id, "DELETE", data);
  }

  //destinos
  getAuxDestinies(data) {
    return this.call("/aux/destinies", "GET", data);
  }
  getAuxDestiny(id) {
    return this.call("/aux/destinies/" + id, "GET");
  }
  postAuxDestiny(data) {
    return this.call("/aux/destinies", "POST", data);
  }
  putAuxDestiny(id, data) {
    return this.call("/aux/destinies/" + id, "PUT", data);
  }
  deleteAuxDestiny(id, data) {
    return this.call("/aux/destinies/" + id, "DELETE", data);
  }

  //locais de instalação
  getAuxInstallTargets(data) {
    return this.call("/aux/install-targets", "GET", data);
  }
  getAuxInstallTarget(id) {
    return this.call("/aux/install-targets/" + id, "GET");
  }
  postAuxInstallTarget(data) {
    return this.call("/aux/install-targets", "POST", data);
  }
  putAuxInstallTarget(id, data) {
    return this.call("/aux/install-targets/" + id, "PUT", data);
  }
  deleteAuxInstallTarget(id, data) {
    return this.call("/aux/install-targets/" + id, "DELETE", data);
  }

  //mercados
  getAuxMarkets(data) {
    return this.call("/aux/markets", "GET", data);
  }
  getAuxMarket(id) {
    return this.call("/aux/markets/" + id, "GET");
  }
  postAuxMarket(data) {
    return this.call("/aux/markets", "POST", data);
  }
  putAuxMarket(id, data) {
    return this.call("/aux/markets/" + id, "PUT", data);
  }
  deleteAuxMarket(id, data) {
    return this.call("/aux/markets/" + id, "DELETE", data);
  }

  //maturidades
  getAuxMaturities(data) {
    return this.call("/aux/maturities", "GET", data);
  }
  getAuxMaturity(id) {
    return this.call("/aux/maturities/" + id, "GET");
  }
  postAuxMaturity(data) {
    return this.call("/aux/maturities", "POST", data);
  }
  putAuxMaturity(id, data) {
    return this.call("/aux/maturities/" + id, "PUT", data);
  }
  deleteAuxMaturity(id, data) {
    return this.call("/aux/maturities/" + id, "DELETE", data);
  }

  // Reports
  getSlaughterUserReports(data) {
    return this.call("/reports/slaughter-users", "GET", data);
  }

  //type negotiation
  getAuxTypeNegotiations(data) {
    return this.call("/aux/type-negotiations", "GET", data);
  }
  getAuxTypeNegotiation(id) {
    return this.call("/aux/type-negotiations/" + id, "GET");
  }
  postAuxTypeNegotiation(data) {
    return this.call("/aux/type-negotiations", "POST", data);
  }
  putAuxTypeNegotiation(id, data) {
    return this.call("/aux/type-negotiations/" + id, "PUT", data);
  }
  deleteAuxTypeNegotiation(id, data) {
    return this.call("/aux/type-negotiations/" + id, "DELETE", data);
  }

  //type produtction
  getAuxTypeProductions(data) {
    return this.call("/aux/type-productions", "GET", data);
  }
  getAuxTypeProduction(id) {
    return this.call("/aux/type-productions/" + id, "GET");
  }
  postAuxTypeProduction(data) {
    return this.call("/aux/type-productions", "POST", data);
  }
  putAuxTypeProduction(id, data) {
    return this.call("/aux/type-productions/" + id, "PUT", data);
  }
  deleteAuxTypeProduction(id, data) {
    return this.call("/aux/type-productions/" + id, "DELETE", data);
  }

  //industrias
  getIndustries(data) {
    return this.call("/industries", "GET", data);
  }
  getIndustry(id) {
    return this.call("/industries/" + id, "GET");
  }
  postIndustry(data) {
    return this.call("/industries", "POST", data);
  }
  putIndustry(data) {
    const { id } = data;
    return this.call("/industries/" + id, "PUT", data);
  }
  deleteIndustry(id, data) {
    return this.call("/industries/" + id, "DELETE", data);
  }
  postIndustryLogo(id, data) {
    return this.call("/industries/logo/" + id, "POST", data);
  }
  putIndustryPdfNotification(id, data) {
    return this.call(`/industries/${id}/pdf-notification`, "PUT", data);
  }

  ///industry-cameras
  getIndustryCameras(data) {
    return this.call("/industry-cameras", "GET", data);
  }
  getIndustryCamera(id) {
    return this.call(`/industry-cameras/${id}`, "GET");
  }
  postIndustryCameras(data) {
    return this.call("/industry-cameras", "POST", data);
  }
  putIndustryCamera(id, data) {
    return this.call(`/industry-cameras/${id}`, "PUT", data);
  }
  deleteIndustryCamera(id) {
    return this.call(`/industry-cameras/${id}`, "DELETE");
  }

  //Cidades
  getAddressCity(id) {
    return this.call("address/cities/" + id, "GET");
  }
  getAddressStates() {
    return this.call("address/states", "GET");
  }
  getAddressCities(data) {
    return this.call("/portal/address/cities", "GET", data);
  }

  //  PluginsUsers
  getPluginsUsers(data) {
    return this.call("/plugins-users/", "GET", data);
  }

  postPluginsUsers(data) {
    return this.call("/plugins-users/", "POST", data);
  }
}

const appApi = new AppApi();

export default appApi;
